import React from "react";
import Header from "./Header";

const PageLayout: React.FC<{
  headerText: string;
  roleAvailable: boolean;
  landingPage?: boolean;
  children: React.ReactNode;
}> = ({ headerText, roleAvailable, landingPage = false, children }) => (
  <>
    <Header
      headerText={headerText}
      roleAvailable={roleAvailable}
      landingPage={landingPage}
    />
    {children}
  </>
);

export default PageLayout;
